import { createModelCanvas } from '../diagram/ModelCanvas.js';
import { diagramHost } from '../workbench/diagramHost.js';
export default createModelCanvas(diagramHost);
